enum VoteType {
  UP = 'UP',
  DOWN = 'DOWN',
}

export default VoteType